export default function selectCardinalPlural(number: number, forms: string[]): string {
	return number === 1 ? forms[0] : forms[1];
}
export function selectCardinalPluralCzech(number: number, forms: string[]): string {
	return number === 1 ? forms[0] : number <= 4 ? forms[1] : forms[2];
}
